import VueTab from '@ui-common/vue-tab';
import getQueryParam from 'get-query-param';
export default {
	props: {
		id: {
			type: String,
			required: true
		},
		activeTabIndex: {
			type: Number,
			default: 0
		}
	},
	components: {
		VueTab
	},
	computed: {
		urlTabId() {
			const urlTabIndex = parseInt(getQueryParam(`${this.id}-tab`, window.location.href), 10) - 1;
			return isNaN(urlTabIndex) ? this.activeTabIndex : urlTabIndex;
		}
	},
	mounted() {
		if (this.$refs[`mtab-${this.id}-root`]) {
			this.$nextTick(() => {
				this.$refs[`mtab-${this.id}-root`].scrollIntoView();
			});
		}
	}
};
